import * as React from 'react';

import { PropertyGallery } from '@shared-ui/lodging-property-details';

import { UitkLayoutPosition } from 'uitk-react-layout-position';

import { SharedUiWrapperProps, withSharedUiPropertyDetails } from './shared-ui-property-details';

export const GalleryWrapper: React.FC<SharedUiWrapperProps> = ({ inputs }) => (
  <UitkLayoutPosition type="relative" position={{ zindex: 'layer1' }}>
    <PropertyGallery inputs={inputs} />
  </UitkLayoutPosition>
);

export const SharedUiGalleryWrapper = withSharedUiPropertyDetails(GalleryWrapper);
SharedUiGalleryWrapper.displayName = 'SharedUiGalleryWrapper';
